import { defineComponent as N, computed as m, h as p } from "vue";
import z from "./ghl-ui.es1077.js";
import I from "./ghl-ui.es1078.js";
import W from "./ghl-ui.es1079.js";
import O from "./ghl-ui.es1080.js";
import T from "./ghl-ui.es854.js";
import w from "./ghl-ui.es855.js";
import { createKey as B } from "./ghl-ui.es384.js";
import { useThemeClass as $ } from "./ghl-ui.es857.js";
import L from "./ghl-ui.es1081.js";
const k = Object.assign(Object.assign({}, w.props), {
  processing: Boolean,
  type: {
    type: String,
    default: "line"
  },
  gapDegree: Number,
  gapOffsetDegree: Number,
  status: {
    type: String,
    default: "default"
  },
  railColor: [String, Array],
  railStyle: [String, Array],
  color: [String, Array],
  viewBoxWidth: {
    type: Number,
    default: 100
  },
  strokeWidth: {
    type: Number,
    default: 7
  },
  percentage: [Number, Array],
  unit: {
    type: String,
    default: "%"
  },
  showIndicator: {
    type: Boolean,
    default: !0
  },
  indicatorPosition: {
    type: String,
    default: "outside"
  },
  indicatorPlacement: {
    type: String,
    default: "outside"
  },
  indicatorTextColor: String,
  circleGap: {
    type: Number,
    default: 1
  },
  height: Number,
  borderRadius: [String, Number],
  fillBorderRadius: [String, Number],
  offsetDegree: Number
}), J = N({
  name: "Progress",
  props: k,
  setup(e) {
    const h = m(() => e.indicatorPlacement || e.indicatorPosition), c = m(() => {
      if (e.gapDegree || e.gapDegree === 0)
        return e.gapDegree;
      if (e.type === "dashboard")
        return 75;
    }), {
      mergedClsPrefixRef: o,
      inlineThemeDisabled: n
    } = T(e), s = w("Progress", "-progress", z, L, e, o), l = m(() => {
      const {
        status: t
      } = e, {
        common: {
          cubicBezierEaseInOut: d
        },
        self: {
          fontSize: g,
          fontSizeCircle: C,
          railColor: u,
          railHeight: y,
          iconSizeCircle: b,
          iconSizeLine: x,
          textColorCircle: S,
          textColorLineInner: P,
          textColorLineOuter: i,
          lineBgProcessing: f,
          fontWeightCircle: v,
          [B("iconColor", t)]: D,
          [B("fillColor", t)]: a
        }
      } = s.value;
      return {
        "--n-bezier": d,
        "--n-fill-color": a,
        "--n-font-size": g,
        "--n-font-size-circle": C,
        "--n-font-weight-circle": v,
        "--n-icon-color": D,
        "--n-icon-size-circle": b,
        "--n-icon-size-line": x,
        "--n-line-bg-processing": f,
        "--n-rail-color": u,
        "--n-rail-height": y,
        "--n-text-color-circle": S,
        "--n-text-color-line-inner": P,
        "--n-text-color-line-outer": i
      };
    }), r = n ? $("progress", m(() => e.status[0]), l, e) : void 0;
    return {
      mergedClsPrefix: o,
      mergedIndicatorPlacement: h,
      gapDeg: c,
      cssVars: n ? void 0 : l,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      type: e,
      cssVars: h,
      indicatorTextColor: c,
      showIndicator: o,
      status: n,
      railColor: s,
      railStyle: l,
      color: r,
      percentage: t,
      viewBoxWidth: d,
      strokeWidth: g,
      mergedIndicatorPlacement: C,
      unit: u,
      borderRadius: y,
      fillBorderRadius: b,
      height: x,
      processing: S,
      circleGap: P,
      mergedClsPrefix: i,
      gapDeg: f,
      gapOffsetDegree: v,
      themeClass: D,
      $slots: a,
      onRender: R
    } = this;
    return R == null || R(), p("div", {
      class: [D, `${i}-progress`, `${i}-progress--${e}`, `${i}-progress--${n}`],
      style: h,
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": t,
      role: e === "circle" || e === "line" || e === "dashboard" ? "progressbar" : "none"
    }, e === "circle" || e === "dashboard" ? p(W, {
      clsPrefix: i,
      status: n,
      showIndicator: o,
      indicatorTextColor: c,
      railColor: s,
      fillColor: r,
      railStyle: l,
      offsetDegree: this.offsetDegree,
      percentage: t,
      viewBoxWidth: d,
      strokeWidth: g,
      gapDegree: f === void 0 ? e === "dashboard" ? 75 : 0 : f,
      gapOffsetDegree: v,
      unit: u
    }, a) : e === "line" ? p(I, {
      clsPrefix: i,
      status: n,
      showIndicator: o,
      indicatorTextColor: c,
      railColor: s,
      fillColor: r,
      railStyle: l,
      percentage: t,
      processing: S,
      indicatorPlacement: C,
      unit: u,
      fillBorderRadius: b,
      railBorderRadius: y,
      height: x
    }, a) : e === "multiple-circle" ? p(O, {
      clsPrefix: i,
      strokeWidth: g,
      railColor: s,
      fillColor: r,
      railStyle: l,
      viewBoxWidth: d,
      percentage: t,
      showIndicator: o,
      circleGap: P
    }, a) : null);
  }
});
export {
  J as default,
  k as progressProps
};
